import * as firebase from 'firebase/app';
import 'firebase/performance';

class FireBaseClient {
  client: firebase.app.App;
  performance: firebase.performance.Performance;

  constructor({
    config,
  }: {
    config: {
      apiKey: string;
      authDomain: string;
      databaseURL: string;
      projectId: string;
      storageBucket: string;
      messagingSenderId: string;
      appId: string;
    };
  }) {
    this.client = firebase.initializeApp(config);
    this.performance = this.client.performance();
  }
}

export default FireBaseClient;
